import { FC } from 'react'

import { TIconProps } from '.'

export const AlarmClock: FC<TIconProps> = ({ color, size }) => {
  return (
    <svg
      data-testid="icon-alarm-clock"
      viewBox="0 0 39 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: size, height: size }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.7229 23.0152H21.5747V18.9517C21.5747 17.8282 20.6455 16.92 19.5007 16.92C18.3558 16.92 17.4266 17.8282 17.4266 18.9517V25.047C17.4266 26.1705 18.3558 27.0787 19.5007 27.0787H25.7229C26.8678 27.0787 27.7969 26.1705 27.7969 25.047C27.7969 23.9234 26.8678 23.0152 25.7229 23.0152ZM19.5007 38.7613C11.7809 38.7613 5.50065 32.6091 5.50065 25.047C5.50065 17.4848 11.7809 11.3327 19.5007 11.3327C27.2204 11.3327 33.5007 17.4848 33.5007 25.047C33.5007 32.6091 27.2204 38.7613 19.5007 38.7613ZM21.5498 6.87909C21.554 6.83643 21.5747 6.80392 21.5747 6.76125V4.72951H23.6488C24.7937 4.72951 25.7229 3.82132 25.7229 2.69776C25.7229 1.57421 24.7937 0.666016 23.6488 0.666016H15.3525C14.2076 0.666016 13.2784 1.57421 13.2784 2.69776C13.2784 3.82132 14.2076 4.72951 15.3525 4.72951H17.4266V6.76125C17.4266 6.80392 17.4473 6.83643 17.4515 6.87909C8.12021 7.88278 0.833984 15.644 0.833984 25.047C0.833984 35.1305 9.2091 43.3327 19.5007 43.3327C29.7922 43.3327 38.1673 35.1305 38.1673 25.047C38.1673 15.644 30.8811 7.88278 21.5498 6.87909Z"
        fill={color}
        style={{
          width: 'auto',
          height: size,
        }}
      />
    </svg>
  )
}
